import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { actionCreators } from './store';
import imgLoginLogo from '../../../assets/images/loginlogo.png';
import Footer from '../../../common/footer';
import './style.css';

class LoginName extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			isChangePassType: false,
		};
		this.togglePassInputType = this.togglePassInputType.bind(this);
	}
	
	//切换密码框的类型
	togglePassInputType(el){
		if(el.type === 'text'){
			this.setState({
				isChangePassType: false
			})
			el.type = 'password'
		}else{
			this.setState({
				isChangePassType: true
			})
			el.type = 'text'
		}
	}
	
	render() {
		const { userName, userPass, errUserName, errUserPass, isUserName, isUserPass, isManuBtnClick,
			handleUserNameChange, handlePasswordChange, validateUserName, validateUserPass, loginf, handleEnterKey } = this.props;
		return (
			<div className="lrlogin">
				<header>
					<div className="headerin mx1200 mauto clear posr">
						<img src={imgLoginLogo} className="fl m30t" alt=""/>
					</div>
				</header>
				<div className="main">
					<div className="mainin mx1200 mauto posr">
						<div className="con posa">
							<div className="top textc">
								密码登录
							</div>
							<div className="down">
								<div className={isUserName ? 'item username errorcon' : 'item username'}>
									<input type="text" value={userName} ref={node => this.userNameEl = node}
										onChange={ev => handleUserNameChange(ev)}
										placeholder="请输入用户名或手机号" 
										onBlur={ev => validateUserName(ev)}/>
									{isUserName ? (
										<div className="error">{errUserName}</div>
									) : null}
								</div>
								<div className={isUserPass ? 'item pass errorcon' : 'item pass'}>
									<input type="password" value={userPass} ref={node => this.passEl = node}
										onChange={ev => handlePasswordChange(ev)}
										placeholder="请输入密码" onKeyPress={ev => handleEnterKey(ev, loginf, this.userNameEl, this.passEl, isUserName, isUserPass)}
										onBlur={ev => validateUserPass(ev)}/>
									{isUserPass ? (
										<div className="error">{errUserPass}</div>
									) : null}
									<div className={this.state.isChangePassType ? 'img imgopen' : 'img'}
										onClick={ev =>　this.togglePassInputType(this.passEl)}></div>
								</div>
								<div className="item wjmm textr">
									<Link to="/forget" className="c_333">
										忘记密码?
									</Link>
								</div>
								<div className="item">
									{isManuBtnClick ? (
										<button type="button" className="opacity8">登录中，请稍后...</button>
									) : (
										<button onClick={ev => loginf(this.userNameEl, this.passEl, isUserName, isUserPass)} type="button" className="cursp">登录</button>
									)}									
								</div>
								<div className="item btext clear">
									<Link to="/logintel" className="c_333 fl">
										短信验证码登录
									</Link>
									<Link to="/register" className="c_333 fr">
										没有账号？立即注册
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		userName: state.getIn(['loginn', 'userName']),
		userPass: state.getIn(['loginn', 'userPass']),
		errUserName: state.getIn(['loginn', 'errUserName']),
		errUserPass: state.getIn(['loginn', 'errUserPass']),
		isUserName: state.getIn(['loginn', 'isUserName']),
		isUserPass: state.getIn(['loginn', 'isUserPass']),
		isManuBtnClick: state.getIn(['loginn', 'isManuBtnClick']),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		handleUserNameChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handleUserNameChange(val));
			dispatch(actionCreators.toggleUserNameErr(false, ''));
		},
		handlePasswordChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handlePasswordChange(val));
			dispatch(actionCreators.togglePassErr(false, ''));
		},
		validateUserName(e) {
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.toggleUserNameErr(true, '您还没有输入用户名或者手机号.'));
				return false;
			}else if(3 > val.length || val.length > 20){
				dispatch(actionCreators.toggleUserNameErr(true, '长度为3到20个字符.'));
				return false;
			}else{
				dispatch(actionCreators.toggleUserNameErr(false, ''));
				return false;
			}
		},
		validateUserPass(e) {
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.togglePassErr(true, '您还没有输入密码.'));
				return false;
			}else if (val.length < 6){
				dispatch(actionCreators.togglePassErr(true, '密码不少于六位，字母、数字都可.'));
				return false;
			}else{
				dispatch(actionCreators.togglePassErr(false, ''));
				return false;
			}
		},
		loginf(userNameEl, passEl, isUserName, isPass) {
			let userName = userNameEl.value;
			let pass = passEl.value;
			if(userName === ''){
				dispatch(actionCreators.toggleUserNameErr(true, '您还没有输入用户名或者手机号.'));
				userNameEl.focus();
				return false;
			}else if(3 > userName.length || userName.length > 20){
				dispatch(actionCreators.toggleUserNameErr(true, '长度需为3到20个字符.'));
				userNameEl.focus();
				return false;
			}else if(pass === ''){
				dispatch(actionCreators.togglePassErr(true, '您还没有输入密码.'));
				passEl.focus();
				return false;
			}else if (pass.length < 6){
				dispatch(actionCreators.togglePassErr(true, '密码不少于六位，字母、数字都可.'));
				passEl.focus();
				return false;
			}
			if(isUserName){
				userNameEl.focus();
				return false;
			}else if(isPass){
				passEl.focus();
				return false;
			}
			dispatch(actionCreators.loginf(userName, pass))
		},
		handleEnterKey(e, loginf, userNameEl, passEl, isUserName, isPass){
			if(e.nativeEvent.keyCode === 13){
				loginf(userNameEl, passEl, isUserName, isPass);
			}
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginName);

